module.exports = __webpack_public_path__ + "static/media/leafIcon.308ac362.svg";